import React, { useState } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useApim } from '../../hooks/useApi';
import { showConfirm } from '../../helpers/MessageUtility';
import { GoFormzServices } from '../../AppSettings';
import GfModal from '../../gfcomponents/GfModal/GfModal';

type TemplateVersion = {
  id: string;
  versionNumber: number;
};

export type ChangeTemplateVersionModalProps = {
  templateId?: string;
  templateVersionId?: string;
  templateName?: string;
  isUnsaved?: boolean;
  onSave: (id: string) => void;
  onClose: VoidFunction;
};

export default function ChangeTemplateVersionModal(props: ChangeTemplateVersionModalProps) {
  const [templateVersions, templateVersionsLoading] = useApim<TemplateVersion[]>(GoFormzServices.TemplateService, `/templates/${props.templateId}/versions`);
  const [versionId, setVersionId] = useState(props.templateVersionId);
  const [isSaving, setIsSaving] = useState(false);

  // sort decending first
  const options =
    templateVersions
      ?.sort((a, b) => b.versionNumber - a.versionNumber)
      .map(({ id, versionNumber }) => ({
        key: id,
        text: `Version ${versionNumber}`,
        value: id,
        icon: id === props.templateVersionId ? 'check' : null
      })) ?? [];

  const onSave = () => {
    if (props.isUnsaved) {
      showConfirm(
        {
          title: 'Confirm',
          msg: 'Any unsaved changes will be saved. Do you want to continue?'
        },
        (result) => {
          if (result) {
            setIsSaving(true);
            props.onSave(versionId);
          }
        }
      );
    } else {
      setIsSaving(true);
      props.onSave(versionId);
    }
  };

  return (
    <GfModal
      title="Template Version"
      loading={isSaving}
      primaryText="Save"
      onClose={props.onClose}
      onPrimaryClick={onSave}
      onTertiaryClick={props.onClose}
      tertiaryText="Cancel"
    >
      <div>
        Updating a form's template version could result in unexpected behavior.
        <br />
        <br />
        This process might include changes to fields, calculations, or other unknown issues.
        <br />
        <br />
      </div>
      <Dropdown
        fluid
        selection
        loading={templateVersionsLoading}
        options={options}
        value={versionId}
        onChange={(_, data) => setVersionId(data.value as string)}
      />
    </GfModal>
  );
}
